import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ColorPickerModule } from "ngx-color-picker";
import { DropzoneModule } from "../../sb-editor-tools/directives/dropzone/dropzone.module";
import { PopupsComponent } from "../../sb-editor-tools/popups/popups.component";
import { PopupscomparatorComponent } from "./popupscomparator.component";
import { ComparatorComponent } from "../../sb-editor-tools/comparator/comparator.component";
import { NgxJsonViewerModule } from "ngx-json-viewer";



@NgModule({
    declarations: [
        PopupscomparatorComponent,
        PopupsComponent,
        ComparatorComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DropzoneModule,
        ColorPickerModule,
        NgxJsonViewerModule,
    ],
    providers: [],
    exports:[
        PopupscomparatorComponent
    ]
})
export class PopupscomparatorModule {}